import { render, staticRenderFns } from "./CardTarjaPapoDeSegunda.vue?vue&type=template&id=71efa059&scoped=true"
import script from "./CardTarjaPapoDeSegunda.vue?vue&type=script&lang=js"
export * from "./CardTarjaPapoDeSegunda.vue?vue&type=script&lang=js"
import style0 from "./CardTarjaPapoDeSegunda.vue?vue&type=style&index=0&id=71efa059&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71efa059",
  null
  
)

export default component.exports